export default __webpack_public_path__ + "media/images/rank_03-0b9be6edcb19472a49c0809a8833c2ec.png";